import { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';

const heroSlides = [
  {
    url: 'https://public.readdy.ai/ai/img_res/8a41b0a4e232f5796c0470ea2b229afa.jpg',
    label: '初次约会',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20walking%20hand%20in%20hand%20through%20blooming%20cherry%20blossom%20park%20on%20a%20bright%20sunny%20spring%20day%2C%20joyful%20expressions%2C%20pink%20petals%20falling%2C%20vivid%20daylight%20colors%2C%20romantic%20lifestyle%20photography%2C%20only%20one%20couple&width=1440&height=900&seq=hero_new_02&orientation=landscape',
    label: '樱花漫步',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20enjoying%20a%20romantic%20picnic%20on%20green%20grass%20in%20a%20sunny%20park%2C%20bright%20afternoon%20light%2C%20colorful%20flowers%2C%20laughing%20and%20sharing%20food%2C%20warm%20vibrant%20daylight%20photography%2C%20only%20one%20man%20and%20one%20woman&width=1440&height=900&seq=hero_new_03&orientation=landscape',
    label: '野餐时光',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20on%20a%20bright%20sunny%20beach%20date%2C%20holding%20hands%20walking%20along%20the%20shore%2C%20clear%20blue%20ocean%2C%20golden%20sand%2C%20sparkling%20sunlight%20on%20water%2C%20joyful%20smiles%2C%20vivid%20travel%20lifestyle%20photography%2C%20only%20one%20couple&width=1440&height=900&seq=hero_new_04&orientation=landscape',
    label: '海边约会',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20very%20handsome%20blonde%20hair%20Western%20Caucasian%20man%20with%20golden%20blond%20hair%20and%20one%20beautiful%20Chinese%20woman%20on%20a%20romantic%20sunny%20outdoor%20date%20at%20a%20garden%20cafe%2C%20bright%20daylight%2C%20both%20smiling%20happily%2C%20warm%20golden%20sunlight%2C%20vibrant%20colors%2C%20intercultural%20couple%20lifestyle%20photography%2C%20only%20one%20man%20and%20one%20woman&width=1440&height=900&seq=hero_new_05&orientation=landscape',
    label: '跨国约会',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20taking%20a%20selfie%20together%20at%20a%20scenic%20viewpoint%20on%20a%20bright%20sunny%20day%2C%20mountains%20and%20blue%20sky%20background%2C%20big%20smiles%2C%20vibrant%20colors%2C%20travel%20photography%20style%2C%20only%20one%20couple&width=1440&height=900&seq=hero_new_06&orientation=landscape',
    label: '旅行留念',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20showing%20engagement%20ring%20together%20outdoors%20on%20a%20bright%20sunny%20day%2C%20joyful%20expressions%2C%20beautiful%20garden%20background%2C%20warm%20golden%20light%2C%20celebratory%20moment%2C%20lifestyle%20photography%2C%20only%20one%20couple&width=1440&height=900&seq=hero_new_07&orientation=landscape',
    label: '浪漫求婚',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20showing%20engagement%20ring%20together%20outdoors%20on%20a%20bright%20sunny%20day%2C%20joyful%20expressions%2C%20beautiful%20garden%20background%2C%20warm%20golden%20light%2C%20celebratory%20moment%2C%20lifestyle%20photography%2C%20only%20one%20couple&width=1440&height=900&seq=hero_new_08&orientation=landscape',
    label: '订婚时刻',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20very%20handsome%20blonde%20hair%20Western%20Caucasian%20man%20with%20golden%20blond%20hair%20and%20one%20beautiful%20Chinese%20woman%20in%20elegant%20wedding%20attire%20on%20a%20bright%20sunny%20day%2C%20outdoor%20garden%20ceremony%2C%20white%20floral%20arch%2C%20bride%20in%20white%20gown%2C%20groom%20in%20suit%2C%20vivid%20daylight%20wedding%20photography%2C%20only%20one%20man%20and%20one%20woman&width=1440&height=900&seq=hero_new_09&orientation=landscape',
    label: '跨国婚礼',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20bride%20in%20traditional%20red%20wedding%20attire%20on%20a%20bright%20sunny%20day%2C%20outdoor%20ceremony%2C%20vibrant%20red%20and%20gold%20decorations%2C%20joyful%20smiles%2C%20high%20quality%20wedding%20photography%2C%20only%20one%20man%20and%20one%20woman&width=1440&height=900&seq=hero_new_10&orientation=landscape',
    label: '中式婚礼',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20at%20an%20elegant%20outdoor%20wedding%20reception%20on%20a%20bright%20sunny%20day%2C%20cutting%20wedding%20cake%20together%2C%20colorful%20floral%20decorations%2C%20joyful%20celebration%2C%20vivid%20lifestyle%20photography%2C%20only%20one%20couple&width=1440&height=900&seq=hero_new_11&orientation=landscape',
    label: '婚礼派对',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20dancing%20together%20at%20their%20outdoor%20wedding%20on%20a%20bright%20sunny%20day%2C%20romantic%20first%20dance%2C%20colorful%20floral%20decorations%2C%20joyful%20celebration%2C%20vivid%20lifestyle%20photography%2C%20only%20one%20couple&width=1440&height=900&seq=hero_new_12&orientation=landscape',
    label: '新婚共舞',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20holding%20a%20newborn%20baby%20together%2C%20young%20parents%20smiling%20brightly%20in%20a%20sunny%20home%2C%20warm%20daylight%20streaming%20through%20windows%2C%20cozy%20and%20joyful%20family%20moment%2C%20lifestyle%20photography%2C%20only%20one%20man%20and%20one%20woman&width=1440&height=900&seq=hero_new_13&orientation=landscape',
    label: '幸福家庭',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20celebrating%20wedding%20anniversary%20at%20a%20beautiful%20outdoor%20garden%2C%20bright%20sunny%20day%2C%20elegant%20table%20with%20flowers%2C%20champagne%20toast%2C%20joyful%20smiles%2C%20vibrant%20colors%2C%20lifestyle%20photography%2C%20only%20one%20couple&width=1440&height=900&seq=hero_new_14&orientation=landscape',
    label: '周年纪念',
  },
  {
    url: 'https://readdy.ai/api/search-image?query=one%20handsome%20Chinese%20man%20and%20one%20beautiful%20Chinese%20woman%20in%20a%20bright%20sunny%20outdoor%20setting%2C%20romantic%20couple%20portrait%2C%20elegant%20fashion%2C%20warm%20golden%20light%2C%20lush%20green%20garden%20background%2C%20high%20quality%20couple%20lifestyle%20photography%2C%20only%20one%20man%20and%20one%20woman&width=1440&height=900&seq=hero_new_15&orientation=landscape',
    label: '幸福时光',
  },
];

export default function HeroSearch() {
  const [gender, setGender] = useState<'female' | 'male'>('female');
  const [ageMin, setAgeMin] = useState(22);
  const [ageMax, setAgeMax] = useState(35);
  const [education, setEducation] = useState('');
  const [location, setLocation] = useState('');
  const [mounted, setMounted] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prevSlide, setPrevSlide] = useState<number | null>(null);
  const [fading, setFading] = useState(false);

  // Drag state
  const cardRef = useRef<HTMLDivElement>(null);
  const dragOffset = useRef({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [cardPos, setCardPos] = useState<{ x: number; y: number } | null>(null);
  const [hasDragged, setHasDragged] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevSlide(currentSlide);
      setFading(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
        setFading(false);
        setPrevSlide(null);
      }, 800);
    }, 4000);
    return () => clearInterval(interval);
  }, [currentSlide]);

  const goToSlide = (idx: number) => {
    if (idx === currentSlide) return;
    setPrevSlide(currentSlide);
    setFading(true);
    setTimeout(() => {
      setCurrentSlide(idx);
      setFading(false);
      setPrevSlide(null);
    }, 800);
  };

  const onMouseDown = useCallback((e: React.MouseEvent) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    dragOffset.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
    setDragging(true);
    e.preventDefault();
  }, []);

  const onTouchStart = useCallback((e: React.TouchEvent) => {
    const card = cardRef.current;
    if (!card) return;
    const touch = e.touches[0];
    const rect = card.getBoundingClientRect();
    dragOffset.current = { x: touch.clientX - rect.left, y: touch.clientY - rect.top };
    setDragging(true);
  }, []);

  useEffect(() => {
    if (!dragging) return;
    const onMouseMove = (e: MouseEvent) => {
      setHasDragged(true);
      setCardPos({
        x: e.clientX - dragOffset.current.x,
        y: e.clientY - dragOffset.current.y,
      });
    };
    const onTouchMove = (e: TouchEvent) => {
      const touch = e.touches[0];
      setHasDragged(true);
      setCardPos({
        x: touch.clientX - dragOffset.current.x,
        y: touch.clientY - dragOffset.current.y,
      });
    };
    const onUp = () => setDragging(false);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onTouchMove, { passive: true });
    window.addEventListener('touchend', onUp);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onUp);
    };
  }, [dragging]);

  const cardStyle: React.CSSProperties = hasDragged && cardPos
    ? {
        position: 'fixed',
        left: cardPos.x,
        top: cardPos.y,
        zIndex: 100,
        opacity: mounted ? 1 : 0,
        transform: dragging ? 'scale(1.02)' : 'scale(1)',
        transition: dragging ? 'transform 0.1s' : 'transform 0.2s',
        cursor: dragging ? 'grabbing' : 'auto',
      }
    : {
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateX(0) scale(1)' : 'translateX(50px) scale(0.95)',
        transition: 'opacity 1s, transform 1s',
        transitionDelay: '200ms',
      };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Slideshow */}
      <div className="absolute inset-0">
        {/* Previous slide (fading out) */}
        {prevSlide !== null && (
          <img
            key={`prev-${prevSlide}`}
            src={heroSlides[prevSlide].url}
            alt={heroSlides[prevSlide].label}
            className="absolute inset-0 w-full h-full object-cover object-top"
            style={{ opacity: fading ? 0 : 1, transition: 'opacity 0.8s ease-in-out' }}
          />
        )}
        {/* Current slide */}
        <img
          key={`curr-${currentSlide}`}
          src={heroSlides[currentSlide].url}
          alt={heroSlides[currentSlide].label}
          className="absolute inset-0 w-full h-full object-cover object-top"
          style={{ opacity: fading ? 0 : 1, transition: 'opacity 0.8s ease-in-out' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-amber-900/70 via-yellow-800/50 to-amber-600/30"></div>
      </div>

      {/* Slide label badge */}
      <div className="absolute top-6 right-8 z-20">
        <span className="bg-white/20 backdrop-blur-sm border border-white/30 text-white text-xs font-medium px-3 py-1.5 rounded-full">
          {heroSlides[currentSlide].label}
        </span>
      </div>

      {/* Promo Banner — Free Trial */}
      <div className="absolute top-24 left-0 right-0 z-20 flex justify-center px-4">
        <Link
          to="/membership"
          className="inline-flex items-center gap-3 bg-gradient-to-r from-emerald-500/90 to-teal-500/90 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2.5 hover:from-emerald-500 hover:to-teal-500 transition-all cursor-pointer group"
        >
          <span className="flex items-center gap-1.5 bg-white/20 rounded-full px-2.5 py-0.5 text-white text-xs font-bold">
            <i className="ri-gift-line"></i>
            限时优惠
          </span>
          <span className="text-white text-sm font-semibold">工厂会员前 <strong className="text-yellow-300">3个月完全免费</strong>，分销商会员永久免费</span>
          <i className="ri-arrow-right-line text-white/70 group-hover:translate-x-1 transition-transform"></i>
        </Link>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-32 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Content */}
        <div
          className="flex-1 text-white text-center lg:text-left transition-all duration-1000"
          style={{ opacity: mounted ? 1 : 0, transform: mounted ? 'translateX(0)' : 'translateX(-50px)' }}
        >
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-shield-check-fill text-green-400 text-sm"></i>
            <span className="text-xs text-white font-semibold">中国唯一 · 100% 真实认证婚恋平台</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" style={{ fontFamily: "'Noto Serif SC', serif" }}>
            富缘佳旺<br />
            <span className="text-yellow-300">幸运缘</span><br />
            <span className="text-2xl md:text-3xl font-medium text-white/80">富缘佳旺 · 您唯一的幸运缘</span>
          </h1>
          <p className="text-white/80 text-base md:text-lg mb-6 max-w-lg mx-auto lg:mx-0 leading-relaxed">
            每位会员均经过 <strong className="text-yellow-300">身份证核验</strong>、<strong className="text-yellow-300">学历证书核实</strong>、 及 <strong className="text-yellow-300">视频1对1认证</strong>，确保您遇见的每一个人都是真实的。
          </p>
          <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-2">
            {[
              { icon: 'ri-video-chat-line', color: 'text-green-400', label: '视频1对1认证' },
              { icon: 'ri-graduation-cap-line', color: 'text-yellow-400', label: '学历学信网核实' },
              { icon: 'ri-briefcase-line', color: 'text-orange-300', label: '工作经历核实' },
              { icon: 'ri-id-card-line', color: 'text-red-300', label: '公安系统实名' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm rounded-full px-3 py-1.5">
                <i className={`${item.icon} ${item.color} text-sm`}></i>
                <span className="text-white/90 text-xs font-medium">{item.label}</span>
              </div>
            ))}
          </div>

          <div className="flex gap-8 mt-8 justify-center lg:justify-start">
            {[
              { num: '500万+', label: '认证会员' },
              { num: '98%', label: '真实率' },
              { num: '280万+', label: '成功牵手' },
            ].map((s, i) => (
              <div
                key={i}
                className="text-center transition-all duration-700"
                style={{ opacity: mounted ? 1 : 0, transform: mounted ? 'translateY(0)' : 'translateY(20px)', transitionDelay: `${400 + i * 150}ms` }}
              >
                <div className="text-2xl font-bold text-yellow-300">{s.num}</div>
                <div className="text-xs text-white/60 mt-1">{s.label}</div>
              </div>
            ))}
          </div>

          {/* Slide dots */}
          <div className="flex gap-1.5 mt-8 justify-center lg:justify-start flex-wrap max-w-xs">
            {heroSlides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => goToSlide(idx)}
                className={`rounded-full transition-all duration-300 cursor-pointer ${idx === currentSlide ? 'w-6 h-2 bg-yellow-300' : 'w-2 h-2 bg-white/40 hover:bg-white/70'}`}
              />
            ))}
          </div>
        </div>

        {/* Right Search Card — Draggable */}
        <div
          ref={cardRef}
          style={cardStyle}
          className="w-full lg:w-[420px] bg-white rounded-2xl p-6 select-none"
        >
          {/* Drag Handle */}
          <div
            onMouseDown={onMouseDown}
            onTouchStart={onTouchStart}
            className="flex items-center justify-between mb-4 cursor-grab active:cursor-grabbing"
            title="拖动移动此卡片"
          >
            <div className="text-center flex-1">
              <span className="text-xs font-semibold text-red-500 uppercase tracking-widest">快速匹配搜索</span>
              <h2 className="text-xl font-bold text-gray-800 mt-1" style={{ fontFamily: "'Noto Serif SC', serif" }}>寻找您的缘分</h2>
            </div>
            <div className="flex flex-col gap-1 px-2 opacity-30 hover:opacity-60 transition-opacity flex-shrink-0">
              <div className="flex gap-1">
                <div className="w-1.5 h-1.5 rounded-full bg-gray-400"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-gray-400"></div>
              </div>
              <div className="flex gap-1">
                <div className="w-1.5 h-1.5 rounded-full bg-gray-400"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-gray-400"></div>
              </div>
              <div className="flex gap-1">
                <div className="w-1.5 h-1.5 rounded-full bg-gray-400"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-gray-400"></div>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <label className="text-xs text-gray-500 font-medium mb-2 block">我在寻找</label>
            <div className="flex gap-2">
              {(['female', 'male'] as const).map((g) => (
                <button
                  key={g}
                  onClick={() => setGender(g)}
                  className={`flex-1 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${gender === g ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
                >
                  {g === 'female' ? '👩 女士' : '👨 男士'}
                </button>
              ))}
            </div>
          </div>

          <div className="mb-4">
            <label className="text-xs text-gray-500 font-medium mb-2 flex justify-between">
              <span>年龄范围</span>
              <span className="text-red-500 font-semibold">{ageMin} - {ageMax} 岁</span>
            </label>
            <div className="flex gap-3 items-center">
              <input type="range" min={18} max={60} value={ageMin} onChange={e => setAgeMin(Number(e.target.value))} className="flex-1 accent-red-600" />
              <input type="range" min={18} max={60} value={ageMax} onChange={e => setAgeMax(Number(e.target.value))} className="flex-1 accent-red-600" />
            </div>
          </div>

          <div className="mb-4">
            <label className="text-xs text-gray-500 font-medium mb-2 block">
              <i className="ri-graduation-cap-line mr-1 text-red-400"></i>学历要求
            </label>
            <select
              value={education}
              onChange={e => setEducation(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-red-400 cursor-pointer"
            >
              <option value="">不限学历</option>
              <option value="bachelor">本科及以上</option>
              <option value="master">硕士及以上</option>
              <option value="phd">博士</option>
              <option value="college">大专</option>
            </select>
          </div>

          <div className="mb-5">
            <label className="text-xs text-gray-500 font-medium mb-2 block">
              <i className="ri-map-pin-line mr-1 text-red-400"></i>所在城市
            </label>
            <select
              value={location}
              onChange={e => setLocation(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-red-400 cursor-pointer"
            >
              <option value="">🌏 全球华人</option>
              <optgroup label="🇨🇳 中国大陆">
                <option value="beijing">🇨🇳 北京 Beijing</option>
                <option value="shanghai">🇨🇳 上海 Shanghai</option>
                <option value="guangzhou">🇨🇳 广州 Guangzhou</option>
                <option value="shenzhen">🇨🇳 深圳 Shenzhen</option>
                <option value="chengdu">🇨🇳 成都 Chengdu</option>
                <option value="hangzhou">🇨🇳 杭州 Hangzhou</option>
              </optgroup>
              <optgroup label="🌏 港澳台">
                <option value="hongkong">🇭🇰 香港 Hong Kong</option>
              </optgroup>
              <optgroup label="🌍 亚太地区">
                <option value="singapore">🇸🇬 新加坡 Singapore</option>
                <option value="sydney">🇦🇺 悉尼 Sydney</option>
                <option value="melbourne">🇦🇺 墨尔本 Melbourne</option>
              </optgroup>
              <optgroup label="🌍 中东">
                <option value="dubai">🇦🇪 迪拜 Dubai</option>
              </optgroup>
              <optgroup label="🌎 欧美">
                <option value="newyork">🇺🇸 纽约 New York</option>
                <option value="london">🇬🇧 伦敦 London</option>
                <option value="paris">🇫🇷 巴黎 Paris</option>
              </optgroup>
            </select>
          </div>

          <button className="w-full bg-gradient-to-r from-red-600 to-red-700 text-white py-3 rounded-full font-semibold text-base hover:from-red-700 hover:to-red-800 transition-all cursor-pointer whitespace-nowrap">
            <i className="ri-search-line mr-2"></i>开始匹配
          </button>

          <div className="flex justify-center gap-4 mt-4 text-xs text-gray-400">
            <span><i className="ri-shield-check-line text-green-500 mr-1"></i>真实认证</span>
            <span><i className="ri-video-line text-red-400 mr-1"></i>视频验证</span>
            <span><i className="ri-lock-line text-gray-400 mr-1"></i>隐私保护</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
